<template>
  <el-dialog :title="title" :visible.sync="open" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <div v-loading="loading">
      <list-view v-if="showType==='list'" :list="list" :form="form" :page="page" @showEdit="showEdit" @showNew="showNew" @choose="chooseAddress" @Refresh="Refresh" @reloadAddress="reloadAddress" @reloadAddressIndex="reloadAddressIndex" />
      <new-address v-if="showType==='new'" @submitSuccess="addressSuccess" />
      <edit-address v-if="showType==='edi'" :address="editAddressData" @editSuccess="editSuccess" />
    </div>
  </el-dialog>
</template>
<script type="es6">
import listView from './listView';
import newAddress from './newAddress';
import editAddress from './editAddress';
import { getPageReceiptAddressList } from '@/API';
export default {
  data () {
    return {
      open: false,
      loading: false,
      list: [],
      showType: 'list', // list new edi
      editAddressData: {},
      form: {
        searchText: ''
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        total: 100
      }
    };
  },
  props: {
    propOpen: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    listView,
    newAddress,
    editAddress
  },
  computed: {
    title () {
      if (this.showType === 'list') {
        return '收货地址列表';
      }
      if (this.showType === 'new') {
        return '新增收货地址';
      }
      if (this.showType === 'edi') {
        return '编辑收货地址';
      }
      return '';
    }
  },
  methods: {
    // 获取列表
    initData () {
      let params = {
        receiverInfoKeyWords: this.form.searchText.trim(),
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      getPageReceiptAddressList(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.list = json.data.list;
          this.page.pageSize = json.data.pageSize;
          this.page.total = json.data.total;
          this.page.pageIndex = json.data.pageNum;
        }
      });
    },
    addressSuccess (val) {
      if (val.type) {
        // 保存并使用
        this.$emit('chooseAddress', val.address);
        this.open = false;
        this.list.push(val.address);
        this.initData();
      } else {
        this.showType = 'list';
        this.list.push(val.address);
        this.initData();
      }
    },
    showEdit (val) {
      this.showType = 'edi';
      this.editAddressData = val;
    },
    showNew (val) {
      this.showType = 'new';
    },
    chooseAddress (val) {
      this.$emit('chooseAddress', val);
    },
    editSuccess (val) {
      this.Refresh();
      this.showType = 'list';
    },
    Refresh () {
      this.initData();
      this.$emit('ChangeDatas');
    },
    reloadAddress (val) {
      this.form.searchText = val;
      this.page.pageIndex = 1;
      this.initData();
    },
    reloadAddressIndex (val) {
      this.page.pageIndex = val;
      this.initData();
    }
  },
  mounted () {
    this.open = this.propOpen;
    this.initData();
  },
  watch: {
    propOpen (val) {
      if (val) {
        this.showType = 'list';
      }
      this.open = val;
    },
    open (val) {
      this.$emit('update:propOpen', val);
      if (!val) {
        this.form.searchText = '';
        this.page.pageIndex = 1;
        this.page.pageSize = 10;
        this.initData();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .adressBox{
    .item{
      display: inline-block;
      margin-right: 15px;
      line-height: 30px;
      &.right{
        float: right;
      }
      &:last-child{
        margin-right: 0;
      }
    }
    .defTab{
      padding: 3px 10px;
      display: inline-block;
      background: #409EFF;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      margin-right: 15px;
    }
  }
</style>
